
import {Component, Model, Prop, Vue} from 'vue-property-decorator';
import {CalculationMethodModalData} from "@/models/Recipes/CalculationMethodModalData";
import vModal from "@/components/vModal.vue";
import vIconWithTooltip from "@/components/vIconWithTooltip.vue";
import {mapState} from "vuex";
import {LocalizationState} from "@/store/modules/LocalizationModule";
import RecipesRepository from "@/utils/API/RecipesRepository";
import {ProteinDailyValueCalculationMethod} from "@/models/Recipes/ProteinDailyValueCalculationMethod";

@Component({
  components: {
    vIconWithTooltip,
    vModal
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule
    }),
  },
})
export default class vCalculationMethodModal extends Vue {
  @Prop() recipeId: number;
  @Model() data: CalculationMethodModalData;
  localizationState: LocalizationState;

  ProteinDailyValueCalculationMethod = ProteinDailyValueCalculationMethod;

  get translations() {
    return this.localizationState.translations;
  }

  updateCaloriesCalculationMethod() {
    // @ts-ignore
    this.$snotify.async(
      this.translations.get("rec_toastr_saving"),
      () =>
        new Promise((resolve, reject) => {
          let model = {
            recipeId: this.recipeId,
            caloriesCalculationMethod: this.data.selectedCalculationMethod,
            dailyValueCalculationMethod: this.data.selectedDailyValueCalculation,
            proteinDvCalculationMethod: this.data.selectedProteinDailyValueCalculation,
            pdcaasScore: this.data.pdcaasScore,
          };

          RecipesRepository.updateCaloriesCalculationMethod(model)
            .then(() => {
              resolve({ body: this.translations.get("rec_calc_method_saved") });
              this.$emit('on-update');
              this.data.closeModal();
            })
            .catch((error) => {
              let message;

              if (error.response) {
                message = error.response.data.errorMessages[0].userVisibleMessage;
              }

              else {
                message = this.translations.get("network_error");
              }

              reject({ body: message });
            });
        }),
      {
        timeout: 2000,
        closeOnClick: true,
      }
    );
  }
}
